





















































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import debounce from 'debounce';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Checkbox from '@/components/Checkbox.vue';
import { IField } from '@/fields/types/field';
import FieldSettingsContainer from '@/fields/context-menu/components/FieldSettingsContainer.vue';
import { EFieldType } from '@/fields/types/enums/field-type';
import Dropdown from '@/components/Dropdown.vue';
import InputTextArea from '@/components/InputTextArea.vue';
import { validationOptions } from '@/fields/constants/validation-options';
import { IValidationOption } from '@/fields/types/validation-option';
import { validateRegex } from '@/helpers/validation.helper';
import { fieldLabelMaxLength, fieldValidationWarningMaxLength } from '@/common/database-max-values';
import { EValidationRegex } from '@/enums/ValidationRegex';

@Component({
  components: {
    Input,
    Button,
    Checkbox,
    FieldSettingsContainer,
    Dropdown,
    InputTextArea,
  },
  data: () => ({
    fieldLabelMaxLength,
    fieldValidationWarningMaxLength,
  }),
})
export default class TextFieldSettings extends Vue {
  @Prop() field!: IField;
  @Prop() height: string;
  @Prop() isTemplate: boolean;

  label: string = this.field.label || '';
  type: EFieldType = this.field.type;
  isRequired: boolean = this.fieldIsRequired;
  validationWarning: string = this.field.validationWarning || '';
  validationRegex: string = this.field.validationRegex || '';
  testValue: string = '';
  invalid: boolean = false;
  completed: boolean = false;
  validationOptions = validationOptions;
  showCustom: boolean = false;
  customRegex: string = '';
  isEditable: boolean = this.field.isEditable;

  debounceValidation: () => void = debounce(this.validateInput, 300);

  mounted() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  @Watch('testValue')
  watchTestValue() {
    this.debounceValidation();
  }

  validateInput(): void {
    if (this.testValue.length === 0) {
      return this.resetValidation();
    }
    if (validateRegex(this.customRegex || this.validationRegex, this.testValue)) {
      return this.setValidationValid();
    }
    return this.setValidationInvalid();
  }

  get fieldIsRequired(): boolean {
    return this.field.isRequired;
  }

  get translatedValidationOptions(): IValidationOption[] {
    return validationOptions.map((option: IValidationOption) => ({
      ...option,
      label: this.$t(option.label).toString(),
    }));
  }

  get warningText(): string {
    return this.validationWarning || this.$t('invalid-field-value-entered').toString();
  }

  get isFormatted(): boolean {
    return this.type === EFieldType.Formatted;
  }

  resetValidation() {
    this.invalid = false;
    this.completed = false;
  }

  setValidationInvalid() {
    this.invalid = true;
    this.completed = false;
  }

  setValidationValid() {
    this.invalid = false;
    this.completed = true;
  }

  handleIsEditable(value: boolean) {
    this.isEditable = value;
  }

  handleValidationChange(checkboxValue: boolean) {
    this.type = checkboxValue ? EFieldType.Formatted : EFieldType.Text;
  }

  handleRequiredChange(required: boolean) {
    this.isRequired = required;
  }

  handleDropdownInput(dropdownValue: string) {
    this.testValue = '';
    this.validationRegex = dropdownValue;
    this.showCustom = dropdownValue === EValidationRegex.Custom;
  }

  handleClick() {
    this.$emit('update', {
      isRequired: this.isRequired,
      label: this.label,
      type: this.type,
      validationWarning: this.validationWarning,
      validationRegex: this.customRegex || this.validationRegex,
      isEditable: this.isEditable,
    });
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleClick();
    }
  }
}
